import React from 'react';
import { motion } from 'framer-motion';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import '../../../styles/Voice.css';

interface ConfirmModalProps {
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  message,
  confirmLabel = 'Confirm',
  danger = false,
  onConfirm,
  onCancel,
}) => (
  <div
    className="voice-modal-backdrop"
    onClick={e => e.target === e.currentTarget && onCancel()}
  >
    <motion.div
      className="voice-modal voice-modal--confirm"
      initial={{ opacity: 0, scale: 0.95, y: 16 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.95, y: 16 }}
      transition={{ type: 'spring', stiffness: 360, damping: 30 }}
    >
      {/* Header */}
      <div className="voice-modal__header">
        <div className="confirm-modal__header-row">
          <div
            className="confirm-modal__icon"
            style={{
              background: danger ? 'rgba(239,68,68,0.12)' : 'rgba(139,92,246,0.12)',
              border: `1px solid ${danger ? 'rgba(239,68,68,0.25)' : 'rgba(139,92,246,0.25)'}`,
              color: danger ? 'var(--accent-red)' : 'var(--accent-purple-light)',
            }}>
            <FiAlertTriangle size={15} />
          </div>
          <div className="voice-modal__title">{title}</div>
        </div>
        <button className="voice-modal__close" onClick={onCancel}><FiX size={16} /></button>
      </div>

      {/* Body */}
      <div
        className="confirm-modal__body"
        style={{
          background: danger ? 'rgba(239,68,68,0.04)' : 'rgba(255,255,255,0.02)',
          border: `1px solid ${danger ? 'rgba(239,68,68,0.12)' : 'var(--border-subtle)'}`,
        }}>
        {message}
      </div>

      {/* Footer */}
      <div className="voice-modal__footer">
        <button className="glass-btn" onClick={onCancel}>Cancel</button>
        <button
          className="glass-btn"
          onClick={onConfirm}
          style={danger ? {
            background: 'linear-gradient(135deg, rgba(239,68,68,0.2), rgba(220,38,38,0.15))',
            border: '1px solid rgba(239,68,68,0.35)',
            color: 'var(--accent-red)',
          } : {
            background: 'var(--gradient-purple)',
            border: '1px solid rgba(139,92,246,0.4)',
            color: 'white',
          }}
        >
          {confirmLabel}
        </button>
      </div>
    </motion.div>
  </div>
);

export default ConfirmModal;
